import React from 'react';

const ControlButton = ({ type, onClick, cssClassStr }) => {
    return (
        <i
            id={type.toLowerCase()}
            alt={type}
            onClick={onClick}
            className={`player-icon ${cssClassStr}`}
        />
    )
}

const PlaybackControls = ({ onClick, playing, repeatType, shuffle }) => {
    const Button = ({ type, cssClassStr }) => {
        return (
            <ControlButton
                type={type}
                onClick={onClick}
                cssClassStr={cssClassStr}
            />
        )
    };

    const ShuffleButton = () => {
        const cssClassStr = shuffle ? "fas fa-random active" : "fas fa-random";
        return (
            <Button type="Shuffle" cssClassStr={cssClassStr} />
        )
    }

    const PlayPauseButton = () => {
        const cssClassStr = playing ? "fa fa-fw fa-pause" : "fa fa-fw fa-play";
        const type = playing ? "Pause" : "Play";
        return (
            <Button type={type} cssClassStr={cssClassStr} />
        )
    }

    const RepeatButton = () => {
        let cssClassStr;
        switch (repeatType) {
            case 1:
                cssClassStr = "fas fa-repeat active";
                break;
            case 2:
                cssClassStr = "fas fa-repeat-1-alt active";
                break;
            default:
                cssClassStr = "fas fa-repeat";
        }

        return (
            <Button type="Repeat" cssClassStr={cssClassStr} />
        )
    }

    return (
        <div className="control-buttons">
            <ShuffleButton />
            <Button type="Previous" cssClassStr="fa fa-fw fa-step-backward" />
            <PlayPauseButton />
            <Button type="Next" cssClassStr="fa fa-fw fa-step-forward" />
            <RepeatButton />
        </div>  
    );
}

export default PlaybackControls; 